/* Loser Gamers redesign — shared behavior */
(function () {
  'use strict';

  // Hero crossfade slideshows: [data-lg-slideshow] cycles child imgs every 3.5s.
  function initSlideshows() {
    document.querySelectorAll('[data-lg-slideshow]').forEach(function (stage) {
      var imgs = stage.querySelectorAll('img');
      if (imgs.length < 2) { if (imgs[0]) imgs[0].classList.add('is-active'); return; }
      var idx = parseInt(stage.dataset.lgOffset || '0', 10) % imgs.length;
      imgs[idx].classList.add('is-active');
      setInterval(function () {
        imgs[idx].classList.remove('is-active');
        idx = (idx + 1) % imgs.length;
        imgs[idx].classList.add('is-active');
      }, 3500);
    });
  }

  // Header cart count, shared across pages.
  window.lgSetCartCount = function (n) {
    document.querySelectorAll('[data-lg-cart-count]').forEach(function (el) { el.textContent = n; });
    accentDigits(document.body);
  };

  // Mobile nav toggle.
  function initNavToggle() {
    var btn = document.querySelector('[data-lg-nav-toggle]');
    var nav = document.querySelector('[data-lg-nav]');
    if (btn && nav) btn.addEventListener('click', function () { nav.classList.toggle('is-open'); });
  }

  // Smooth scroll for same-page anchors.
  function initSmoothScroll() {
    document.addEventListener('click', function (e) {
      var a = e.target.closest('a[href*="#"]');
      if (!a) return;
      var url = new URL(a.href, location.href);
      if (url.pathname !== location.pathname || !url.hash) return;
      var target = document.querySelector(url.hash);
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth' });
      history.pushState(null, '', url.hash);
    });
  }

  // Brand quirk: digits inside light text render in the accent green.
  // Skips money (any text with a currency symbol), accent-background zones,
  // form fields, and anything marked data-lg-no-num.
  var NUM_SKIP = 'script,style,input,select,textarea,button,.lg-btn,.lg-cart-pill,.lg-band,.lg-card__price,[data-lg-no-num]';
  function accentDigits(root) {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        var t = node.nodeValue;
        if (!/\d/.test(t)) return NodeFilter.FILTER_REJECT;
        if (/[$€£]/.test(t)) return NodeFilter.FILTER_REJECT;
        var el = node.parentElement;
        if (!el || el.closest(NUM_SKIP)) return NodeFilter.FILTER_REJECT;
        if (el.classList.contains('lg-num')) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    var nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(function (node) {
      var text = node.nodeValue, frag = document.createDocumentFragment(), last = 0, m, re = /\d+/g;
      while ((m = re.exec(text)) !== null) {
        if (m.index > last) frag.appendChild(document.createTextNode(text.slice(last, m.index)));
        var span = document.createElement('span');
        span.className = 'lg-num';
        span.style.color = 'var(--accent)';
        span.textContent = m[0];
        frag.appendChild(span);
        last = m.index + m[0].length;
      }
      if (last < text.length) frag.appendChild(document.createTextNode(text.slice(last)));
      node.parentNode.replaceChild(frag, node);
    });
  }

  function initAll() { initSlideshows(); initNavToggle(); initSmoothScroll(); accentDigits(document.body); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else { initAll(); }
})();
